module.exports = __webpack_public_path__ + "static/media/calendar_icon.5d899718.svg";